"use client";


import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { MapPin, Clock, Mail, Car, Train, Shield, Eye, Lock } from "lucide-react";
import { SectionTitle } from "@/components/ui/section-title";

export default function VisitUs() {
  return (
    <section className="wrapper bg-foreground text-background py-medium">
      <div className="max-w-screen-2xl w-full mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Google Map Embed */}
          <div className="order-2 lg:order-1">
            <div className="relative h-[400px] lg:h-full lg:min-h-[600px] rounded-xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed/v1/place?key=AIzaSyB2NIWI3Tv9iDPrlnowr_0ZqZWoAQydKJU&q=36%20Hatton%20Garden%2C%20London%2C%20EC1N%208EB%2C%20UK&maptype=roadmap"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="We Buy Your Watches Location"
                className="absolute inset-0"
              />
            </div>
          </div>

          {/* Information Accordions */}
          <div className="order-1 lg:order-2 space-y-6">
            <div className="text-left mb-12">
              <div className="flex items-center gap-2 pb-2 opacity-80">
                {/*<Image src={Logo} alt="" className="size-6"/>*/}
                <SectionTitle className="text-h6 font-display mt-0.5">
                  Visit Our Showroom
                </SectionTitle>
              </div>
              <h2 className="text-h2 text-balance">
                Secure &amp; Professional Watch Authentication
              </h2>
              <p className="text-p-large text-balance max-w-lg pt-2">
                Experience our discreet, secure environment where your timepieces are handled with expert care.
              </p>
            </div>

            <Accordion type="single" collapsible className="w-full">
              <AccordionItem value="address">
                <AccordionTrigger className="text-left">
                  <div className="flex items-center gap-3">
                    <MapPin className="h-5 w-5 text-brand grayscale-75" />
                    <span className="text-h5">Address &amp; Contact</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pt-4 space-y-4">
                  <div className="space-y-3">
                    <div className="flex items-start gap-3">
                      <MapPin className="h-4 w-4 text-background mt-1 flex-shrink-0" />
                      <div>
                        <p className="text-p font-medium">36 Hatton Garden</p>
                        <p className="text-p-small opacity-80">London,<br></br> EC1N 8EB</p>
                        <p className="text-p-small opacity-80">United Kingdom</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <Mail className="h-4 w-4 text-background flex-shrink-0" />
                      <a href="mailto:info@webuyyourwatches.co.uk" className="hover:text-primary transition-colors">
                        info@webuyyourwatches.com
                      </a>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="hours">
                <AccordionTrigger className="text-left">
                  <div className="flex items-center gap-3">
                    <Clock className="h-5 w-5 text-brand grayscale-75" />
                    <span className="text-h5">Consultation Hours</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pt-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <h4 className="text-p font-medium mb-2">Monday - Friday</h4>
                      <p className="text-p-small opacity-80">9:00 AM - 5:00 PM</p>
                    </div>
                    <div>
                      <h4 className="text-p font-medium mb-2">Saturday</h4>
                      <p className="text-p-small opacity-80">By Appointment Only</p>
                    </div>
                    <div>
                      <h4 className="text-p font-medium mb-2">Sunday</h4>
                      <p className="text-p-small opacity-80">By Appointment Only</p>
                    </div>
                    <div className="sm:col-span-2 mt-4 p-3 bg-background rounded-md">
                      <p className="text-p-small font-medium text-primary">Private appointments available outside regular hours</p>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="security">
                <AccordionTrigger className="text-left">
                  <div className="flex items-center gap-3">
                    <Shield className="h-5 w-5 text-brand grayscale-75" />
                    <span className="text-h5">Security &amp; Safety</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pt-4 space-y-4">
                  <div>
                    <h4 className="text-base font-medium mb-2 flex items-center gap-2">
                      <Lock className="h-4 w-4" />
                      Secure Environment
                    </h4>
                    <ul className="text-p-small opacity-80 space-y-1 ml-6">
                      <li>• CCTV monitoring &amp; alarm systems</li>
                      <li>• Private consultation rooms available</li>
                      <li>• Discrete entrance for high-value items</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-base font-medium mb-2 flex items-center gap-2">
                      <Eye className="h-4 w-4" />
                      Expert Authentication
                    </h4>
                    <ul className="text-p-small opacity-80 space-y-1 ml-6">
                      <li>• Professional-grade authentication tools</li>

                    </ul>
                  </div>
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="transport">
                <AccordionTrigger className="text-left">
                  <div className="flex items-center gap-3">
                    <Car className="h-5 w-5 text-brand grayscale-75" />
                    <span className="text-h5">Parking &amp; Access</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pt-4 space-y-4">
                  <div>
                    <h4 className="text-p font-medium mb-2 flex items-center gap-2">
                      <Car className="h-4 w-4" />
                      Parking
                    </h4>
                    <ul className="text-p-small opacity-80 space-y-1 ml-6">
                      <li>• Secure on-site parking available</li>
                      <li>• CCTV monitored parking area</li>
                      <li>• Easy access from main road</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-base font-medium mb-2 flex items-center gap-2">
                      <Train className="h-4 w-4" />
                      Public Transport
                    </h4>
                    <ul className="text-p-small opacity-80 space-y-1 ml-6">
                      <li>• Chancery Lane Underground Station - 5 minutes walk</li>
                      <li>• Farringdon Station - 7 minutes walk</li>
                      <li>• Multiple bus routes serving Hatton Garden</li>
                    </ul>
                  </div>
                  <div className="sm:col-span-2 mt-4 p-3 bg-background rounded-md">
                    <p className="text-foreground text-p-small font-medium">
                      Located in the heart of London&#x27;s historic jewellery quarter
                    </p>
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
